module.exports = __webpack_public_path__ + "img/logo-main-new.898d871b.png";